import { supabase } from "@/integrations/supabase/client";

export type SharePlatform =
  | "copy"
  | "native"
  | "x"
  | "facebook"
  | "linkedin"
  | "whatsapp"
  | "email"
  | "other";

interface TrackShareInput {
  platform: SharePlatform;
  /** Where the share was triggered from, e.g. "landing", "roast_public", "invite_dialog". */
  surface?: string;
  url?: string;
  referralCode?: string | null;
  context?: Record<string, unknown>;
}

/** Fire-and-forget analytics for share/copy events. Never throws. */
export async function trackShare({
  platform,
  surface,
  url,
  referralCode,
  context,
}: TrackShareInput) {
  try {
    const { data: { user } } = await supabase.auth.getUser();
    await supabase.from("share_events").insert({
      user_id: user?.id ?? null,
      platform,
      surface: surface ?? null,
      url: url ?? (typeof window !== "undefined" ? window.location.href : null),
      referral_code: referralCode ?? null,
      context: (context ?? {}) as never,
      user_agent:
        typeof navigator !== "undefined" ? navigator.userAgent.slice(0, 500) : null,
    });
  } catch {
    // swallow
  }
}
